import MicrospecFlowCommonContactForm from "../MicrospecFlowCommonContactForm";
import MicrospecFlowCommonFooter from "../MicrospecFlowCommonFooter";

const MicrospecFlowCommonFooterSections = () => {
    return (
        <footer>
            {/* Common Footer Content */}
            <MicrospecFlowCommonContactForm />
            <MicrospecFlowCommonFooter />
        </footer>
    )
}

export default MicrospecFlowCommonFooterSections;